import * as types from "./actionTypes";

export const apiSuccess = (actionType, data) => ({
  type: types.API_SUCCESS,
  payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
  type: types.API_FAIL,
  payload: { actionType, error },
});

// charts data
export const getChartsData = (periodType) => ({
  type: types.GET_CHARTS_DATA,
  payload: periodType
});

export const fetchEmployeeDashboard = (payload) => ({
  type: types.FETCH_EMPLOYEE_DASHBOARD_REQUEST,
  payload,
});

export const sendBirthdayWishes = (payload) => ({
  type: types.SEND_BIRTHDAY_WISHES_REQUEST,
  payload,
});

export const fetchHRDashboard = (payload) => ({
  type: types.FETCH_HR_DASHBOARD_REQUEST,
  payload,
});

export const fetchHODDashboard = (payload) => ({
  type: types.FETCH_HOD_DASHBOARD_REQUEST,
  payload,
});

export const fetchOrgChart = (payload) => ({
  type: types.FETCH_ORG_CHART_REQUEST,
  payload,
});

export const fetchHODDashboardProjectview = (payload) => ({
  type: types.FETCH_HOD_DASHBOARDPROJECTVIEW_REQUEST,
  payload,
});

export const fetchHRDashboardProjectview = (payload) => ({
  type: types.FETCH_HR_DASHBOARDPROJECTVIEW_REQUEST,
  payload,
});